// Shared homepage stories data used across multiple landing pages.
export const homepageStories: ApiSchema<'ResumeStoryCardData'>[] = [
  {
    id: '1',
    videos: [{
      url: 'https://cdn.bestjobs.eu/homepagestory/9cf4d8b3-f424-467a-b12a-92fb1e0615ae/media-720p.m3u8',
      thumbnailUrl: 'https://cdn.bestjobs.eu/homepagestory/9cf4d8b3-f424-467a-b12a-92fb1e0615ae/thumbnail.png',
      id: '',
      name: '',
      question: '',
      locale: '',
      permanentVideoUrl: '',
      hidden: false,
    }],
    privateInformation: {
      name: 'Florin',
      interviewVideoStatus: 'completed',
    },
    leadExperience: {
      title: 'FullStack Engineer',
      company: 'Dazzlerlabs',
    },
    location: 'București',
  },
  {
    id: '2',
    videos: [{
      url: 'https://cdn.bestjobs.eu/homepagestory/10e27a5f-bbfc-4c07-8f64-88e514747580/media-720p.mp4',
      thumbnailUrl: 'https://cdn.bestjobs.eu/homepagestory/10e27a5f-bbfc-4c07-8f64-88e514747580/thumbnail.png',
      id: '',
      name: '',
      question: '',
      locale: '',
      permanentVideoUrl: '',
      hidden: false,
    }],
    privateInformation: {
      name: 'Denisa',
      interviewVideoStatus: 'completed',
    },
    leadExperience: {
      title: 'Social media and PR Specialist',
      company: 'DrGreen',
    },
    location: 'Cluj-Napoca',
  },
  {
    id: '3',
    videos: [{
      url: 'https://cdn.bestjobs.eu/homepagestory/f33178a5-1a88-4cba-b216-4598bc593d5e/media-720p.m3u8',
      thumbnailUrl: 'https://cdn.bestjobs.eu/homepagestory/f33178a5-1a88-4cba-b216-4598bc593d5e/thumbnail.png',
      id: '',
      name: '',
      question: '',
      locale: '',
      permanentVideoUrl: '',
      hidden: false,
    }],
    privateInformation: {
      name: 'Kristofi',
      interviewVideoStatus: 'completed',
    },
    leadExperience: {
      title: 'IT Support',
      company: 'EVERIENCE',
    },
    location: 'Cluj-Napoca',
  },
  {
    id: '4',
    videos: [{
      url: 'https://cdn.bestjobs.eu/homepagestory/73e72f91-1677-4666-996b-31812c51ac75/media-720p.mp4',
      thumbnailUrl: 'https://cdn.bestjobs.eu/homepagestory/73e72f91-1677-4666-996b-31812c51ac75/thumbnail.png',
      id: '',
      name: '',
      question: '',
      locale: '',
      permanentVideoUrl: '',
      hidden: false,
    }],
    privateInformation: {
      name: 'Cezara',
      interviewVideoStatus: 'completed',
    },
    leadExperience: {
      title: 'Team Manager',
      company: 'TELUS International',
    },
    location: 'București',
  },
  {
    id: '5',
    videos: [{
      url: 'https://cdn.bestjobs.eu/homepagestory/cf2fa35c-a4c4-4a9a-82a1-2593e7c68a64/media-720p.m3u8',
      thumbnailUrl: 'https://cdn.bestjobs.eu/homepagestory/cf2fa35c-a4c4-4a9a-82a1-2593e7c68a64/thumbnail.png',
      id: '',
      name: '',
      question: '',
      locale: '',
      permanentVideoUrl: '',
      hidden: false,
    }],
    privateInformation: {
      name: 'David',
      interviewVideoStatus: 'completed',
    },
    leadExperience: {
      title: 'Customer support',
      company: 'MBS Source, (Mercer Island)',
    },
    location: 'București',
  },
  {
    id: '6',
    videos: [{
      url: 'https://cdn.bestjobs.eu/homepagestory/iVideo_49845466_5334d9b2-d123-4134-b646-2a499767a331.mp4',
      thumbnailUrl: 'https://cdn.bestjobs.eu/homepagestory/49845466_5334d9b2-d123-4134-b646-2a499767a331/thumbnail.png',
      id: '',
      name: '',
      question: '',
      locale: '',
      permanentVideoUrl: '',
      hidden: false,
    }],
    privateInformation: {
      name: 'David',
      interviewVideoStatus: 'completed',
    },
    leadExperience: {
      title: 'Digital Strategist & Advisor',
      company: 'Optimist Coaching and Training',
    },
    location: 'Craiova',
  },
  {
    id: '7',
    videos: [{
      url: 'https://cdn.bestjobs.eu/homepagestory/3a0037e5-eed9-4574-a7e7-db5cd202499f/media-720p.m3u8',
      thumbnailUrl: 'https://cdn.bestjobs.eu/homepagestory/3a0037e5-eed9-4574-a7e7-db5cd202499f/thumbnail.png',
      id: '',
      name: '',
      question: '',
      locale: '',
      permanentVideoUrl: '',
      hidden: false,
    }],
    privateInformation: {
      name: 'Alina',
      interviewVideoStatus: 'completed',
    },
    leadExperience: {
      title: 'Child day care worker',
      company: 'Echipa Vesela',
    },
    location: 'București',
  },
  {
    id: '8',
    videos: [{
      url: 'https://cdn.bestjobs.eu/homepagestory/4efdbf24-d652-474e-a60d-5c2747245096/media-720p.m3u8',
      thumbnailUrl: 'https://cdn.bestjobs.eu/homepagestory/4efdbf24-d652-474e-a60d-5c2747245096/thumbnail.png',
      id: '',
      name: '',
      question: '',
      locale: '',
      permanentVideoUrl: '',
      hidden: false,
    }],
    privateInformation: {
      name: 'Stefan',
      interviewVideoStatus: 'completed',
    },
    leadExperience: {
      title: 'Broker financiar',
      company: 'OVB Allfinanz',
    },
    location: 'Brașov',
  },
];
